import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { BanksPanel } from "@/pages/AdminStockMasters";
import { toast } from "sonner";

export default function StockBanks() {
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/stock/meta").then(({ data }) => setMeta(data)).catch((e) => toast.error(apiError(e))); }, []);
  return (
    <div className="space-y-4" data-testid="stock-banks">
      <h1 className="font-heading text-2xl font-extrabold tracking-tight">Funding banks <span className="text-muted-foreground font-medium text-base">· hypothecation terms behind the carrying-cost estimate</span></h1>
      {meta && <BanksPanel readOnly={!meta.can_edit_banks} />}
    </div>
  );
}
